'use strict'

module.exports = [
	{
		'_id': '5c788953bbebe8769ab4b078',
		'name': 'Existing-Plus-Addition Residential Report',
		'description': '',
		'price': 189,
		'sku': '1002',
		'dateCreated': '2000-10-14T23:51:48Z',
		'lastUpdate': '2000-10-14T23:51:48Z',
		'isActive': true
	},
	{
		'_id': '5c788953bbebe8769ab4b079',
		'name': 'Plan Sheet Documentation sent by Priority Mail',
		'description': '',
		'price': 55,
		'sku': '5003',
		'dateCreated': '2000-10-15T06:07:31Z',
		'lastUpdate': '2019-03-01T19:06:50.695Z',
		'isActive': true
	},
	{
		'_id': '5c788953bbebe8769ab4b07a',
		'name': 'Preliminary Run Results',
		'description': 'Preliminary Run results only<br>\r\nYou will receive the C-2R file generated by the energy simulation program on the first run.',
		'price': 39,
		'sku': '2001',
		'dateCreated': '2000-10-14T22:55:12Z',
		'lastUpdate': '2000-10-14T23:41:42Z',
		'isActive': true
	},
	{
		'_id': '5c788953bbebe8769ab4b07b',
		'name': 'Heating and Cooling Load Calculations',
		'description': 'Heating and Cooling Load Calculations only',
		'price': 39,
		'sku': '2002',
		'dateCreated': '2000-10-14T22:55:59Z',
		'lastUpdate': '2000-10-14T22:55:59Z',
		'isActive': true
	},
	{
		'_id': '5c788953bbebe8769ab4b07c',
		'name': 'Rush Service',
		'description': 'Rush Service<br>\r\nSubmit before 12:00pm Pacific, and your report will be e-mailed by 3:00pm, or will be mailed overnight for delivery on the next morning.',
		'price': 85,
		'sku': '3001',
		'dateCreated': '2000-10-14T23:02:41Z',
		'lastUpdate': '2000-10-14T23:02:41Z',
		'isActive': true
	},
	{
		'_id': '5c788953bbebe8769ab4b07e',
		'name': 'Standard email Delivery',
		'description': 'Standard email delivery (8&frac12;\' x 11\' report in PDF format)',
		'price': 0,
		'sku': '4001',
		'dateCreated': '2000-10-14T23:33:24Z',
		'lastUpdate': '2000-10-14T23:33:24Z',
		'isActive': true
	},
	{
		'_id': '5c788953bbebe8769ab4b07f',
		'name': 'CAD Sheet Documentation by email',
		'description': 'I need the important report pages (Forms CF-1R & MF-1R) as files ready for large format plotting, or placing in a CAD document.',
		'price': 55,
		'sku': '4002',
		'dateCreated': '2000-10-14T23:43:59Z',
		'lastUpdate': '2002-10-07T15:51:13Z',
		'isActive': true
	},
	{
		'_id': '5c788953bbebe8769ab4b07d',
		'name': 'Certification by Certified Energy Analyst',
		'description': 'I want this report signed & stamped by a Certified Energy Analyst',
		'price': 10,
		'sku': '3002',
		'dateCreated': '2000-10-14T23:05:26Z',
		'lastUpdate': '2000-10-14T23:13:30Z',
		'isActive': true
	},
	{
		'_id': '5c788953bbebe8769ab4b080',
		'name': 'Report Copy sent by Priority Mail',
		'description': 'Report Copy sent by Priority Mail (allow 3 business days for delivery).',
		'price': 25,
		'sku': '5001',
		'dateCreated': '2000-10-14T23:45:51Z',
		'lastUpdate': '2002-10-07T15:52:29Z',
		'isActive': true
	},
	{
		'_id': '5c788953bbebe8769ab4b081',
		'name': 'Additional Report Copies sent by Priority Mail',
		'description': 'Additional Report Copies sent by Priority Mail',
		'price': 5,
		'sku': '5002',
		'dateCreated': '2000-10-15T06:08:19Z',
		'lastUpdate': '2019-03-01T03:47:11.003Z',
		'isActive': true
	},
	{
		'_id': '5c788953bbebe8769ab4b077',
		'name': 'Standard Residential Report',
		'description': 'Title 24 Energy Compliance Report for submission to the Building Department.',
		'price': 149,
		'sku': '1001',
		'dateCreated': '2000-10-14T22:06:08Z',
		'lastUpdate': '2019-05-13T04:04:40.270Z',
		'isActive': true
	}
]



// WEBPACK FOOTER //
// ../easytitle24-2.x-common/services/mock-data/product.js